var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { t, Translate } from "../../../../../I18N";
import { Modal, Button } from "../../../../Components/UI";
import { InputField } from "../../../../Components/Forms";
import { save as saveThesauri } from "../../../../api/thesauri";
import { useSetAtom, useAtomValue } from 'jotai';
import { notificationAtom, thesauriAtom } from "../../../../atoms";
import { sanitizeThesaurusName } from "../../../../../../shared/sanitizationUtils";





export const AddThesaurusModal = ({ onClose }) => {
  const [name, setName] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const setNotifications = useSetAtom(notificationAtom);
  const setThesauri = useSetAtom(thesauriAtom);
  const thesauri = useAtomValue(thesauriAtom);
  const [nameError, setNameError] = useState(false);

  const handleClose = () => {
    setName('');
    onClose();
  };

  const save = async () => {
    const newThesaurus = {
      name: sanitizeThesaurusName(name),
      values: []
    };
    const savedThesaurus = await saveThesauri(newThesaurus);
    setThesauri([...thesauri, savedThesaurus]);
    setNotifications({
      type: 'success',
      text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Thesaurus created successfully.")
    });
  };

  const handleSave = async () => {
    const isDuplicateName = thesauri.some(
      (thesaurus) => thesaurus.name.toLowerCase() === sanitizeThesaurusName(name).toLowerCase()
    );

    if (isDuplicateName) {
      setNameError(true);
      return;
    }

    setIsSaving(true);
    try {
      await save();
    } catch (error) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Error creating thesaurus.")
      });
    } finally {
      setIsSaving(false);
      handleClose();
    }
  };

  return (/*#__PURE__*/
    _jsx(Modal, { size: "md" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h1", { className: "text-xl font-medium text-gray-900" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add thesaurus")
    ), /*#__PURE__*/
    _jsx(Modal.CloseButton, { onClick: handleClose })
    ), /*#__PURE__*/
    _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-4" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      id: "thesaurus-name",
      label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Name"),
      value: name,
      onChange: (e) => {
        setName(e.target.value);
        setNameError(false);
      },
      placeholder: t('System', 'Thesaurus name', null, false),
      hasErrors: nameError,
      errorMessage:
      nameError && name ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Thesaurus name already exists") : '' }

    ), /*#__PURE__*/
    _jsx("div", { className: "flex justify-end gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "outline", onClick: handleClose }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, {
      color: "success",
      onClick: handleSave,
      disabled: isSaving || !sanitizeThesaurusName(name) }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    )
    ));

};